<template>
	<grid-box rows="auto auto auto 1fr" class="c-white camera-container pt-3">
		<div class="text-center py-2 px-3 mb-3 g-relative">
			<van-icon
				name="arrow-left"
				size="38rem"
				class="arrow-icon"
				@click="$emit('close')"
			/>
			<span class="font_large">上传</span>
		</div>
		<!-- 视频区域 -->
		<div class="g-relative mx-auto video-box">
			<video ref="videoRef" autoplay playsinline></video>
			<!-- 透明提示 -->
			<slot name="mask"></slot>
		</div>
		<!-- 样本示例 -->
		<div class="sample mt-3 font_small_x text-center">
			<div v-show="error" class="error mt-2">{{ error }}</div>
			<slot name="sample">
				<template v-if="sampleImage">
					<img :src="sampleImage" />
					<div class="g-relative" style="color: #bbb; bottom: 25rem">样本</div>
				</template>
			</slot>
		</div>

		<div class="text-center" style="align-self: end">
			<div class="font_large">
				拍摄 <span class="c-main">{{ name }}</span>
			</div>
			<div class="font_small_x my-2" style="color: #bbb">
				请勿缺失、模糊、强光
			</div>

			<grid-box
				columns="1fr 1fr 1fr"
				align="center"
				justify="center"
				class="px-3 pb-3"
				style="
					height: calc(30vh - 150rem);
					max-height: 360rem;
					min-height: 250rem;
				"
			>
				<div></div>
				<flex-box
					align="center"
					justify="center"
					class="r-full"
					style="width: 160rem; height: 160rem; background: #4080ff"
					@click.native="capture"
				>
					<img
						src="./assets/shooter.png"
						alt=""
						style="width: 80rem; height: 80rem"
					/>
				</flex-box>
				<img
					src="./assets/ablum.png"
					style="width: 48rem"
					@click="() => $refs.input.click()"
				/>
			</grid-box>
		</div>
	</grid-box>
	<input type="file" ref="input" hidden @change="ablumUpload" />
</template>

<script setup>
import { ref, defineProps, defineEmits, toRefs, computed } from 'vue'
import useCamera from '@/composition/use-camera'

const { name, sampleImage } = defineProps({ name: String, sampleImage: String })

// 将 video 元素绑定到 videoRef
const videoRef = ref(null)

const { error, isCameraActive, toggleCamera, takePhoto } = useCamera(videoRef)

const emit = defineEmits(['take-photo'])
// 拍照
const capture = async () => {
	const file = await takePhoto()
	emit('take-photo', file)
}
// 相册
const ablumUpload = (ev) => {
	const file = ev.target.files[0]
	if (file) {
		emit('take-photo', file)
	}
	ev.target.value = ''
}
</script>

<style scoped lang="scss">
.camera-container {
	position: fixed;
	z-index: 999;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: #2e2e2e;
}
.video-box {
	width: 700px;
	height: 420px;
	background: #000;

	video {
		width: 700px;
		height: 420px;
		object-fit: cover;
		background: #000;
	}
}
.sample {
	img {
		display: block;
		margin-inline: auto;
		width: 256px;
		height: 256px;
		object-fit: contain;
		object-position: center;
	}
}
.arrow-icon {
	position: absolute;
	left: $space-3;
	top: 50%;
	transform: translateY(-50%);
}

.error {
	color: red;
}
img {
	max-width: 100%;
}
</style>
